<template>
  <div class="page_content explore_entity_inside career programs" aria-label="Career Jobs">
    <div class="row page-heading">
      <div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
        <div class="module_icon ico-career"></div>
        <template v-if="career && career.name">
          <career-title :career="career"></career-title>
        </template>
      </div>
      <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
        <div class="btn_container" v-if="showBackToResultButton">
          <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
            <span class="btn_ic ic-back"></span>
            <span class="btn_txt"> {{ deCamelCase() }} </span>
          </b-btn>
        </div>
      </div>
    </div>
    <div class="page_content_container">
      <career-navigation :active="'jobs'" :code="code" :cipCode="cipCode" :returnTo="returnTo"></career-navigation>
      <div class="row pg_content">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
          <div class="row pg_sec sec_filter">
            <div class="col-12 hd ace_sec_hd" aria-label="Filter by State or City">
              <h2>Filter by State or City</h2>
              <span class="hd_bdr"></span>
            </div>
            <div class="col-12" style="margin-left: 2%;">
              <b-input-group class="row frm_sec">
                <div class="col-11 frm_fld_col">
                  <div class="row">
                    <div class="frm_fld state">
                      <label for="state">Select State</label>
                      <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                        :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''"></v-select>
                      <span class="fld_info">
                      <span v-if="disableSelectState">To select state clear the city selection first</span>
                      </span>
                    </div>
                    <div class="frm_label">
                      <label>OR</label>
                    </div>
                    <div class="frm_fld city">
                      <label for="city">Select City</label>
                      <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                        :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''"></v-select>
                      <span class="fld_info">
                      <span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-1 frm_btn_col">
                  <b-btn @click="goButtonClicked" aria-label="Go">Go</b-btn>
                </div>
              </b-input-group>
            </div>
          </div>
          <div class="row pg_sec">
            <div class="col-12 hd ace_sec_hd" aria-label="Jobs Postings">
              <div>
                <h2>Jobs Postings</h2>
              </div>
              <span class="hd_bdr"></span>
            </div>
            <div class="col-12 sec_content" v-if="totalElements > 0">
              <div class="row" v-if="numberOfElementsText">
                <div class="col-6">
                  <div class="ml-2">
                    <input v-model="searchTerm" placeholder="type to narrow results" class="search_term">
                    <div class="clear-btn" v-if="this.searchTerm.length > 0" @click="goButtonClicked">
                      <b-btn @click="searchTerm = ''" aria-label="clear">X</b-btn>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="float-right btn_container pagination_sty3 mt-1" style="max-width: none;">
                    <button type="button" :disabled="firstPage" @click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                    <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
                    <button type="button" :disabled="lastPage" @click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                  </div>
                  <div class="float-right mr-4">
                    <span><b>{{numberOfElementsText}}</b> of <b>{{totalElements}}</b></span>
                    <span class="ml-3">
                      <b-form-select size="sm" :options="limitOptions" v-model="limit" style="width: 20px; height: 20px;" />
                    </span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 gph_sec ace_sec" style="margin-left: 2%;">
                  <div class="time_chart_container">
                    <div class="row">
                      <template v-for="jobPosting in filteredJobPostings">
                        <div class="col-12 bar_block bar_block_item">
                          <div class="bar_block_inner pointer" style="padding: 5px;" :id="jobPosting.jobId" @click="showSelectedJobPosting(jobPosting)">
                            <div class="row">
                              <div class="col-12 bar_title" style="margin-left: 0px;"><span>{{jobPosting.jobTitle}}</span></div>
                              <div class="col-12 bar_val_1" style="margin-left: 0px;">Employer <span>{{jobPosting.employer}}</span></div>
                              <div class="col-12 bar_val_1" style="margin-left: 0px;">Location <span>{{jobPosting.location}}</span></div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
            <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
          </div>
        </b-modal>
      </div>      
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import CareerNavigation from './CareerNavigation'
  import moment from 'moment'
  
  export default {
    name: 'careerJobs',
    props: ['code', 'cipCode', 'returnTo', 'showBackToResultButton'],
    components: {
      CareerTitle,
      CareerNavigation
    },
    data: () => {
      return {
        career: {},
        DEFAULT_RETURN_TO: 'exploreCareerResults',
        EXPLORE_RESULTS: 'exploreCareerResults',
        page: 0,        
        offset: 0,
        limit: 10,
        searchTerm: '',
        firstPage: true,
        lastPage: false,
        totalElements: 0,
        numberOfElements: 0,
        numberOfElementsText: '',
        insightJobsPostings: {},
        limitOptions: [10, 25, 50],
        stateCodes: {1: 'AL', 2: 'AK', 4: 'AZ', 5: 'AR', 6: 'CA', 8: 'CO', 9: 'CT', 10: 'DE', 11: 'DC', 12: 'FL', 13: 'GA', 15: 'HI', 16: 'ID', 17: 'IL', 18: 'IN', 19: 'IA', 20: 'KS', 21: 'KY', 22: 'LA', 23: 'ME', 24: 'MD', 25: 'MA', 26: 'MI', 27: 'MN', 28: 'MS', 29: 'MO', 30: 'MT', 31: 'NE', 32: 'NV', 33: 'NH', 34: 'NJ', 35: 'NM', 36: 'NY', 37: 'NC', 38: 'ND', 39: 'OH', 40: 'OK', 41: 'OR', 42: 'PA', 72: 'PR', 44: 'RI', 45: 'SC', 46: 'SD', 47: 'TN', 48: 'TX', 49: 'UT', 50: 'VT', 51: 'VA', 78: 'VI', 53: 'WA', 54: 'WV', 55: 'WI', 56: 'WY'},
        selectedState: null,
        selectedMetroArea: null,
        disableSelectState: false,
        disableSelectMetroArea: false
      }
    },
  
    mounted () {
      this.loadDataForCareerJobs()
    },
  
    methods: {
      ...mapActions([
        'loadLogDashboardActivity',
        'loadCareer',
        'loadInsightJobsPostings',
        'loadInsightJobPosting'
      ]),
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      async loadDataForCareerJobs () {
        this.career = await this.loadCareer({code: this.code, loadDataFromServer: true})
        await this.populateInsightJobsPostings(false)
        this.loadLogDashboardActivity({action: 'viewCareerJobs', page: 'careerJobs', link: '', careerSocCode: this.code})
      },
      async next () {
        this.page += 1
        this.offset = this.page * this.limit
        this.firstPage = (this.offset === 0)
        await this.populateInsightJobsPostings(true)
        this.numberOfElements += this.insightJobsPostings.count
        this.numberOfElementsText = ((this.offset + 1) + ' - ' + this.numberOfElements)
        if ((this.totalElements - this.insightJobsPostings.offset) <= this.insightJobsPostings.count) {
          this.lastPage = true
        }
      },
      async prev () {
        this.page -= 1
        this.lastPage = false
        this.offset = this.page * this.limit
        this.firstPage = (this.offset === 0)
        if (this.numberOfElements > 0) {
          this.numberOfElements -= this.insightJobsPostings.count
        }
        await this.populateInsightJobsPostings(true)
        this.numberOfElementsText = ((this.offset + 1) + ' - ' + this.numberOfElements)
      },
      async populateInsightJobsPostings (isNextPrev) {
        this.showLoader()
        let payload = this.insightJobsPostingsPayload
        this.insightJobsPostings = await this.loadInsightJobsPostings(payload)
        this.totalElements = this.insightJobsPostings.totalCount
        if (!isNextPrev) {
          this.lastPage = (this.totalElements <= this.limit)
          this.numberOfElements = this.insightJobsPostings.count
          this.numberOfElementsText = ((this.offset + 1) + ' - ' + this.numberOfElements)          
        }
        this.hideLoader()
      },
      async goButtonClicked () {
        this.resetFilterData()        
        await this.populateInsightJobsPostings(false)
      },
      async showSelectedJobPosting (item) {
        this.showLoader()
        let title = item.jobTitle
        let html = await this.loadInsightJobPosting(item.jobId)
        let posting = window.open('', 'Job Posting: ' + title, 'height=700,width=1200,status=no,left=200')
        posting.document.open()
        posting.document.write(html)
        this.hideLoader()
      },
      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to career results'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return result
      },
      formatOptionsForVSelect (map, isState) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          if (isState) {
            formatted.push({id: key, label: map[key], code: this.stateCodes[key]})
          } else {
            formatted.push({id: key, label: map[key]})
          }
        })
        formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
        return formatted
      },
      resetFilterData () {
        this.page = 0        
        this.offset = 0
        this.limit = 10
        this.searchTerm = ''
        this.firstPage = true
        this.lastPage = false
      },
      resetInsightJobPostingData () {
        this.resetFilterData()
        this.totalElements = 0
        this.numberOfElements = 0
        this.numberOfElementsText = ''
        this.insightJobsPostings = {}        
      }
    },
  
    computed: {
      ...mapState({
        'geoIdMap': state => state.career.geoIdMap,
      }),
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds, true)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds, false)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds, false)
        }
        return formattedMap
      },
      insightJobsPostingsPayload () {
        let bgtocc = this.career.name
        let location = '([nationwide]: \"nationwide\")'
        let state = (this.selectedState && this.selectedState.code) ? this.selectedState.code : null
        let msa = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : null
        if (state) {
          location = '([state]: \"' + state + '\")'
        } else if (msa) {
          msa += ' (Metropolitan Statistical Area)'
          location = '([msa]: \"' + msa + '\")'
        }
        let payload = {
          'groupBy': 'JobPosting',
          'queryString': location + ' and ([bgtocc]: \"' + bgtocc + '\")',
          'geography': 'US',
          'timePeriod': {
            'from': moment().subtract(8, 'days').format(),
            'to': moment().subtract(1, 'days').format()
          },
          'includeTotalClassifiedPostings': true,
          'includeTotalUnclassifiedPostings': true,
          'offset': this.offset,
          'limit': this.limit
        }
        return payload
      },
      filteredJobPostings () {
        return this.insightJobsPostings.data.filter(item => {
          return item.jobTitle.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
      }
    },
  
    watch: {
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
        }        
      },
      selectedMetroArea (newMSA) {
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
        }
      },
      limit (newLimit) {
        this.page = 0
        this.offset = 0
        this.firstPage = true
        this.lastPage = false
        this.populateInsightJobsPostings(false)
      }
    }
  }
</script>

<style>
  .pointer {
    cursor: pointer;
  }

  .bar_block_item {
    flex: 100% !important;
    max-width: 97% !important;
    background: #f5f5f5 !important;
  }

  .search_term {
    float: left;
    width: 350px;
    height: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/app/career/components/CareerJobs.vue